/*  MUI  */
import { CheckCircle, CloseRounded } from '@mui/icons-material';

/*  React  */
import React from 'react';

export const Checkmark = ({ checked }) => {
    if (!checked) {
        return (
            <CloseRounded
                sx={{ color: 'icon.danger', height: '24px', width: '24px' }}
            />
        );
    }

    return (
        <CheckCircle
            sx={{ color: 'icon.success', height: '24px', width: '24px' }}
        />
    );
};
